    <div class="container-fluid loader-container">
    <app-loader *ngIf="loading == true"></app-loader>

    <section *ngIf="item">
        <header class="d-flex space-between page-header">
            <h2>
                <span class="text-muted" (click)="viewCourse()">Methodes</span><span
                    class="seperator">/</span>{{item['title']}}
            </h2>
            <div class="actions">
                <div ngbDropdown class="d-inline-block">
                    <button type="button" class="btn btn-primary" ngbDropdownToggle>
                        Acties
                    </button>
                    <div ngbDropdownMenu>
                        <button (click)="sync()" ngbDropdownItem>Sync</button>
                        <button (click)="openModal(content, item['id'])" ngbDropdownItem>Wijzig</button>
                        <button (click)="delete(item)" ngbDropdownItem>Verwijder</button>
                    </div>
                </div>
            </div>
        </header>

        <div class="row">
            <div class="col-3">
                <div class="card">
                    <div class="card-header d-flex space-between">
                        <h5 class="card-title">
                            Informatie
                        </h5>
                    </div>
                    <div class="card-body p-0">
                        <table class="table table-striped m-0">
                            <tbody>
                                <tr>
                                    <td class="ps-4">
                                        Titel
                                    </td>
                                    <td>
                                        {{item['title']}}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="ps-4">
                                        Code
                                    </td>
                                    <td>
                                        {{item['code']}}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="ps-4">
                                        Link
                                    </td>
                                    <td>
                                        <a [href]="item['url']" target="_blank"
                                            class="external-link">{{item['url']}}</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="card">
                    <div class="card-header d-flex space-between">
                        <h5 class="card-title">
                            Koppeling
                        </h5>
                    </div>
                    <div class="card-body p-0">
                        <table class="table table-striped m-0">
                            <tbody>
                                <tr>
                                    <td class="ps-4">
                                        Endpoint
                                    </td>
                                    <td>
                                        {{item['endpoint']}}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="ps-4">
                                        Client
                                    </td>
                                    <td>
                                        {{item['client']}}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="ps-4">
                                        Secret
                                    </td>
                                    <td>
                                        {{item['secret']}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="card mb-4">
                    <div class="card-header d-flex space-between">
                        <h5 class="card-title">
                            Afbeelding
                        </h5>
                        <div class="card-buttons">
                            <!-- The hidden file input element -->
                            <input type="file" accept="image/*" #fileInput style="display: none"
                                (change)="onFileSelected($event)">

                            <!-- Your button -->
                            <button class="btn btn-link btn-icon" (click)="triggerFileInput()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                    class="bi bi-plus-lg" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd"
                                        d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                </svg>
                            </button>

                        </div>
                    </div>
                    <div class="card-body card-table imageBox">
                        <div class="photo-list">
                            <div class="photo-box" *ngIf="courseImage">
                                <div class="cursor-zoom">
                                    <img class="thumb" (click)="openImagePreview(courseImage)"
                                        [src]="courseImage">
                                </div>
                                <div class="cursor-pointer p-2" (click)="removeImage()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-trash" viewBox="0 0 16 16">
                                        <path
                                            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                        <path
                                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                    </svg>
                                </div>
                            </div>
                            <div *ngIf="!courseImage">
                                <small>Nog geen afbeelding geüpload.</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="card mt-4">

                    <div class="row">
                        <div class="col-3">
                            <div class="card-header">
                                <h5 class="card-title">
                                    Vakken
                                </h5>
                            </div>
                            <div class="card-body">
                                <ul class="section-list">
                                    <li *ngFor="let section of sections">
                                        <span (click)="setActiveSection(section)" [ngClass]="{
                                        'active': !activeSection || section['id'] === activeSection['id']
                                        }">
                                            {{section['title']}}
                                            <small class="text-muted" *ngIf="section['active'] == 1">Actief</small>
                                            <small class="text-muted" *ngIf="section['active'] != 1">Niet actief</small>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-9">
                            <div *ngIf="activeSection">
                                <div class="card-header">
                                    <h5 class="card-title">
                                        Modules
                                    </h5>
                                </div>
                                <div class="card-body ps-3">
                                    <table class="table chapter-list">
                                        <thead>
                                            <tr>
                                                <th>Module</th>
                                                <th>URL</th>
                                                <th>Lessen</th>
                                                <th>Actief</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let chapter of activeSection['chapters']">
                                                <td>{{chapter['title']}}</td>
                                                <td><a [href]="item['url'] + 'module/' + chapter['slug']"
                                                        target="_blank" class="external-link">/{{chapter['slug']}}</a>
                                                </td>
                                                <td>{{chapter['lesson_count']}}</td>
                                                <td>
                                                    <span *ngIf="chapter['active'] == 1">Actief</span>
                                                    <span *ngIf="chapter['active'] != 1">Niet actief</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title">
            <span *ngIf="currentItemId == ''">Methode toevoegen</span>
            <span *ngIf="currentItemId != ''">Methode wijzigen</span>
        </h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x"
                viewBox="0 0 16 16">
                <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
        </button>
    </div>
    <div class="modal-body">
        <app-course-information-form [modalInstance]="modal" [itemId]="currentItemId"></app-course-information-form>
    </div>
</ng-template>